export default {
  text: '#868786',
  primary: '#c7e9f0',
  secondary: '#223e66',
  background: 'white',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#484848'
}
